import {DOM} from "../helpers/DOM.js";
import {Helper} from "../helpers/Helper.js";
import {Datatables} from "./Datatables.js";

export default class Modals {
	#admin_ajax = '';
	#datatables = {};

	constructor() {
		this.#admin_ajax = admin_ajax[0];
		this.initButtons();
	}

	initButtons() {
		DOM.addEvent('click', '.levcharity_modal', (event, button) => {
			setTimeout(() => {
				if (button?.dataset?.modal === 'datatable') {
					this.datatableModal(button);
				} else if (button?.dataset?.modal === 'html') {
					this.htmlModal(button);
				}
			}, 10)
		});
	}

	async datatableModal(button) {
		const {Components} = await import('../helpers/Components.js' /* webpackChunkName: "components" */);

		const modal = Components.modals();

		modal.type('popup')
			.className('datatable-modal')
			.closeOnOutsideClick(false)
			.header(`<h1 class="levcharity_heading">${button.dataset?.datatableHeading || ''}</h1>`, true)
			.body(`<div class="levcharity_fetch_datatable"></div>`)

		modal.show();

		this.#fetchDatatable(button)
			.then(response => {
				const wrapper = DOM.el('.levcharity_fetch_datatable', modal.modal);
				if (response?.html) {
					if (wrapper) {
						wrapper.innerHTML = response.html;

						setTimeout(() => {
							const table = DOM.el('table', wrapper)

							if (table) {
								table.id = 'dt' + Helper.hash(response.html);
								new Datatables(table);
							}

							wp.hooks.doAction('levCharityRenderPopupDatatable', button, wrapper)
						})
					}
				} else {
					if (wrapper) {
						wrapper.innerHTML = `<p class="levcharity_paragraph">${wp.i18n.__('Something went wrong. Please try again later.')}</p>`;
					}
				}
			})
			.catch(error => {
				const wrapper = DOM.el('.levcharity_fetch_datatable', modal.modal);

				if (wrapper) {
					wrapper.innerHTML = `<p class="levcharity_paragraph">${wp.i18n.__('Something went wrong. Please try again later.')}</p>`;
				}
			})
	}

	async htmlModal(button) {
		const {Components} = await import('../helpers/Components.js' /* webpackChunkName: "components" */);

		const modal = Components.modals();

		modal.type('popup')
			.className('html-modal')
			.closeOnOutsideClick(false)
			.header(`<h1 class="levcharity_heading">${button.dataset?.title || ''}</h1>`, true)
			.body(`<div class="levcharity_popup_html"></div>`)

		modal.show();

		await Helper.request(
			this.#admin_ajax,
			{
				action: button?.dataset?.action || '',
				token: button?.dataset?.token || '',
				data: JSON.parse(button?.dataset?.data || '{}'),
			}
		)
			.then(response => {
				const wrapper = DOM.el('.levcharity_popup_html', modal.modal);
				if (response?.html) {
					if (wrapper) {
						wrapper.innerHTML = response.html;
						setTimeout(() => {
							wp.hooks.doAction('levCharityRenderPopupHtml', button, wrapper)
						})
					}
				} else {
					if (wrapper) {
						wrapper.innerHTML = `<p class="levcharity_paragraph">${wp.i18n.__('Something went wrong. Please try again later.')}</p>`;
					}
				}
			})
			.catch(error => {
				const wrapper = DOM.el('.levcharity_fetch_datatable', modal.modal);

				if (wrapper) {
					wrapper.innerHTML = `<p class="levcharity_paragraph">${wp.i18n.__('Something went wrong. Please try again later.')}</p>`;
				}
			})
	}

	#fetchDatatable(button) {
		return Helper.request(this.#admin_ajax, {
			action: 'levcharity_fetch_datatable_structure',
			token: button.dataset.datatableToken,
			datatable: button.dataset.datatable,
			data: JSON.parse(button.dataset.datatableData),
		})
	}
}
